/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ImageTypeEnum } from '../models/ImageTypeEnum';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class FileService {
    /**
     * Get Aspect Ration
     * @param imageType
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAspectRationUploadRatioImageTypeGet(
        imageType: ImageTypeEnum,
    ): CancelablePromise<number> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/upload/ratio/{image_type}',
            path: {
                'image_type': imageType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
}
